import { graphql } from 'react-relay';

export const userGeoInfoQuery = graphql`
    query userGeoInfoQuery($cookieDomain: String = "") {
        viewer {
            regionalInfo(cookieDomain: $cookieDomain) {
                countryCode
                zipCode
                regionsByZipCode {
                    displayName
                    urlLabel
                }
                incomeLevel {
                    incomeBracket
                    incomePercentile
                }
            }
        }
    }
`;
